/**
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */

import { GOOGLEMAPREGION, STORELOCATORLIBRARY } from "../_foundation/constants/common";

//localStorage persist days
export const PERMANENT_STORE_DAYS = 30;

// this should be common for all useJsApiLoader otherwise it'll throw an error
export const GMAPS_API_LOADER_CONFIG = {
  id: "google-map-script",
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY || "",
  region: GOOGLEMAPREGION,
  libraries: STORELOCATORLIBRARY,
};
